// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/image-full-with-text/image-full-with-text.component.scss
// module id = 566
// module chunks = 0